export enum enumProviderType {
    MATENIMIENTO = 1,
    ALMACEN = 2,
    COMBUSTIBLE = 3,
    CLIENTE = 4
}
